import { gsap, Bounce, Power2 } from "gsap";
import { TextStyleConfig } from "../../config/translate/TextStyleConfig";
import { SymbolData } from "../../../core/reel/symbol/config/SymbolData";
import { Helper } from "../../../core/utils/Helper";

export class SymbolMultiplyCounter extends PIXI.Text {

    private tl:gsap.core.Timeline;
    private currAmm:number;

    public get curAmm():number{
        return this.currAmm ?? 0;
    }

    constructor(amm?:number){
        super("")
        this.style.align = "center";
        this.style = TextStyleConfig.MULTIPLIER_TEXT;
        this.anchor.set(0.5);
        if(amm)this.apply(amm);
    }

    public apply(amount:number):void{
        if(!amount) return;
        this.text = "x" + amount.toString();
        this.visible = amount > 1;
        this.currAmm = amount;
    }

    public addValue(amount:number,duration:number = 0.25):gsap.core.Timeline{
        this.tl = Helper.setTimeline(this.tl!,{},true);
        if(amount <= 1) return this.tl;
        this.text = "x" + amount.toString();
        this.visible = amount > 1;
        const startScale = this.scale.x * 1.35;
        const toSCale = this.scale.x;
        if(duration){
            this.tl.fromTo(this.scale,{x:startScale,y:startScale},{duration:duration, x:toSCale,y:toSCale, ease: "Bounce.easeOut"},0);
            this.tl.fromTo(this,{alpha:0},{duration:duration,alpha:1, ease: "Power2.easeOut"},0);
        }
        this.currAmm = amount;
        return this.tl;
    }
}